import * as OneTrust from './OneTrustConsentMonitor'

const MAX_RETRIES = 120
const RETRY_INTERVAL = 500
class ConsentMonitor {

  /**
   * @param {Object} options
   * @param {({ entity: string, consents: Array<string> }) => void} options.onChange 
   */
  constructor({ onChange }) {
    this.retries = 0
    this.onChange = onChange
    this.waitForConsentEntities({ OneTrust })
  }

  destroy() {
    if(this._waiting)
      clearTimeout(this._waiting)
  }

  waitForConsentEntities(entities) {
    entities = Object.entries(entities).reduce((remain, [key,entity]) => {
      try {
        if(!entity.init(consents => {
          this.onChange({ entity: key, consents })
        })) {
          // if init resolves failing, we add to retrying entities
          remain[key] = entity
        }
        return remain
      } catch(e) {
        // if it fails to attempt init without return
        // we exclude it from retrying
        return remain
      }
    }, {})
    this.retries++
    if(this.retries < MAX_RETRIES && Object.keys(entities).length > 0) {
      this._waiting = setTimeout(() => this.waitForConsentEntities(entities), RETRY_INTERVAL)
    }
  }

}

export { ConsentMonitor }